import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { AccountPageLoadEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgChipotleURewardsHeadBanner',
})
export default class CmgChipotleURewardsHeadBanner extends Vue {
  mounted() {
    this.$services.loyalty.refreshPoints();
  }

  get chipotleULogo(): string {
    return this.$appStore.state.cms.images.loyalty.chipotleULogo.default;
  }

  get backgroundImage(): string | undefined {
    return this.isMobile ? this.$appStore.state.cms.images.loyalty.rewardsHeadBannerBackground.mobile :
    this.$appStore.state.cms.images.loyalty.rewardsHeadBannerBackground.desktop;
  }

  get rewardsCount() {
    return this.$appStore.state.customer.wallet.promotions.length;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get isServiceOnline(): boolean {
    return !this.$appStore.state.reward.unreachable;
  }

  get isRewardsOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsOnline ?? true;
  }

  get rewardsExchangeOfflineMessage(): string {
    return `We're having trouble with our Rewards ${ !this.isRewardsOnline ? '' : 'Exchange ' }but you can still order, earn points and use existing rewards. Check back later.`;
  }

  get offlineMessage(): string {
    return `We're having some trouble getting your points.`;
  }

  onClickAddReward(event:any) {
        this.$services.googleAnalytics.sendCustomEvent({
        category: AnalyticsEventCategory.RewardsLanding,
        action: AnalyticsEventAction.AddRewardClick,
        label: AnalyticsEventLabel.AddRewardClick,
      });
      this.$services.ui.pushEventTargetAsLastSelectedElement(event);
      this.$services.ui.setModalVisibility('addReward', true);
      this.$services.analytics.send(new AccountPageLoadEvent('rewards-add-rewards'));
      this.$services.ui.firstFocus();
    }

  onClickRewardsExtras() {
    this.$router.push({ name: Routes.RewardsExtras });
  }

  onClickScanReminder() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.ForgotToScanClick,
      label: AnalyticsEventLabel.RewardsForgotToScanClick,
    });
    this.$router.push({ name: Routes.RetroCredit });
  }

  onClickPointsHistory() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.ViewPointHistoryClick,
      label: AnalyticsEventLabel.ViewPointHistoryClick,
    });
    this.$services.ui.nextFocus('points');
    this.$router.push({ name: Routes.RewardsPointsHistory });
  }
}
